import { LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CompanyEntity } from '@nk/data-entities-lib';
import { NkToastrService } from '@nk/ui-lib';
import { OrgnrPipe } from '../../pipes/orgnr.pipe';

function copyToClipboard(text: string): boolean {
  const input = document.createElement('input');
  input.setAttribute('value', text);
  document.body.appendChild(input);
  input.select();
  const result = document.execCommand('copy');
  document.body.removeChild(input);
  return result;
}

@Component({
  selector: 'nk-company-org-nr',
  imports: [TranslateModule, OrgnrPipe, LowerCasePipe],
  templateUrl: './company-org-nr.component.html',
  styleUrls: ['company-org-nr.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyOrgNrComponent {
  public company = input.required<CompanyEntity>();
  public showFlag = input(true);
  public showSchema = input(false);
  public disableClipboardCopy = input(false);

  constructor(
    private _toastrService: NkToastrService,
    private _translateService: TranslateService,
  ) {}

  public copyToClipboard(event: Event, orgNr: CompanyEntity['org_nr']): void {
    if (this.disableClipboardCopy()) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    copyToClipboard(orgNr);
    const message = this._translateService.instant(
      extractTranslation('company.copy_company_org_nr.message_copied'),
    ) as string;
    this._toastrService.success(`${message}: ${orgNr}`);
  }
}
